import { ArticleItemTopWithBg } from '@/cmsComponents/ArticleItemTopWithBg';
import { useAnalytics } from '@/utils/useAnalytics';
import React from 'react';
import { IArticleSummary } from 'types/cms';

import Grid from '@material-ui/core/Grid';

interface RelatedArticlesProps {
  article: IArticleSummary;
  articles: IArticleSummary[];
}

export const RelatedArticles: React.FC<RelatedArticlesProps> = ({ article, articles }) => {
  const track = useAnalytics();
  return (
    <Grid container spacing={3}>
      {articles.map(relatedArticle => (
        <Grid key={relatedArticle.id} item xs={12} md={4}>
          <ArticleItemTopWithBg
            key={relatedArticle.slug}
            article={relatedArticle}
            onClick={() => {
              track('Click Related Article', {
                title: relatedArticle.title,
                id: relatedArticle.id,
                source_title: article.title,
                source_id: article.id,
              });
            }}
          />
        </Grid>
      ))}
    </Grid>
  );
};
